import { AppServices } from "../AppServices";

export class IntercomManager {
    static TrackEvent(appServices: AppServices, eventName: string): void {
        const isIntercomDisabled = appServices.userContext?.intercomIsDisabled ?? false;

        if (isIntercomDisabled || appServices.config.inTestingMode || !appServices.config.isProductionServer) {
            return;
        }

        Intercom("trackEvent", eventName);
    }
}